import {
  Box,
  Button,
  MenuItem,
  Stack,
  Text,
  alpha,
  styled,
} from '@ltvco/refresh-lib/theme';

export const ViewSelectRow = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: theme.spacing(1.5),
  overflow: 'visible',
  zIndex: 20,
}));

export const ViewSelectCluster = styled(Box)({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  overflow: 'visible',
  zIndex: 20,
});

export const ViewSelectButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  width: 336,
  height: 39,
  padding: '8px 12px',
  columnGap: theme.spacing(1),
  borderRadius: 1000,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  cursor: 'pointer',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: 336,
  },
}));

export const ViewSelectButtonLabel = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  columnGap: 8,
});

export const ViewSelectMenuHeader = styled('li')(({ theme }) => ({
  display: 'block',
  width: '100%',
  listStyle: 'none',
  margin: 0,
  marginBottom: 19,
  padding: 0,
  fontFamily: theme.typography.fontFamily,
  fontSize: 12,
  fontWeight: 700,
  lineHeight: '16px',
  letterSpacing: 0,
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
}));

export const ViewSelectMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  columnGap: 16,
  width: '100%',
  minHeight: 0,
  boxSizing: 'border-box',
  padding: 16,
  borderRadius: 12,
  whiteSpace: 'normal',
  fontFamily: theme.typography.fontFamily,
  backgroundColor: 'transparent',
  '& + &': {
    marginTop: 8,
  },
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
  '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
}));

export const ViewSelectMenuItemIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  color: theme.palette.primary.main,
  '& > svg': {
    fontSize: 24,
  },
}));

export const ViewSelectMenuItemCopy = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  minWidth: 0,
  rowGap: 8,
});

export const ViewSelectMenuItemTitle = styled(Text)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  margin: 0,
}));

export const ViewSelectMenuItemDescription = styled(Text)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.text.secondary,
  margin: 0,
}));

export const IntroTooltipRoot = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  right: 'calc(100% + 12px)',
  transform: 'translateY(-50%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
  width: 270,
  padding: 16,
  gap: theme.spacing(1),
  borderRadius: 4,
  backgroundColor: theme.palette.common.white,
  filter: 'drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.12))',
  zIndex: 21,
  [theme.breakpoints.down('sm')]: {
    top: 'calc(100% + 12px)',
    right: 0,
    transform: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '50%',
    right: -6,
    width: 12,
    height: 12,
    marginTop: -6,
    backgroundColor: theme.palette.common.white,
    transform: 'rotate(45deg)',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export const IntroTooltipTitle = styled(Text)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  margin: 0,
  width: '100%',
}));

export const IntroTooltipBody = styled(Text)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.text.primary,
  margin: 0,
  width: '100%',
}));

export const IntroTooltipCta = styled(Button)(({ theme }) => ({
  borderRadius: 1000,
  padding: theme.spacing(0.75, 2),
  marginTop: theme.spacing(0.5),
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: 0,
  textTransform: 'none',
  boxShadow: 'none',
  backgroundColor: theme.palette.primary.main,
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.dark,
  },
}));
